export const BaseSettingsCell = {
  avatar: (value: string) => (
    <div className="flex min-w-0 items-center gap-3">
      <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-accent text-sm font-label text-primary">
        {value[0]?.toUpperCase()}
      </div>
      <span dir="auto" className="truncate font-label">
        {value}
      </span>
    </div>
  ),
};
